module.exports = __webpack_public_path__ + "static/media/TETHYS.9f611e13.svg";